import { render, staticRenderFns } from "./PublicBeranda.vue?vue&type=template&id=8c50663c&"
import script from "./PublicBeranda.vue?vue&type=script&lang=js&"
export * from "./PublicBeranda.vue?vue&type=script&lang=js&"
import style0 from "./PublicBeranda.vue?vue&type=style&index=0&id=8c50663c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports